import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import { IIntegration } from "../../../../app/models/company";
import { observer } from "mobx-react-lite";
import {
  combineValidators,
  composeValidators,
  hasLengthLessThan,
  isRequired,
  hasLengthGreaterThan,
  matchesPattern,
} from "revalidate";
import { toast } from "react-toastify";
import TextInput from "../../../../app/common/form/TextInput";

const validate = combineValidators({
  apiKey: composeValidators(
    isRequired({ message: "La API KEY es obligatoria" }),
    hasLengthLessThan(257)({
      message: "La API KEY debe tener máximo 256 caracteres",
    }),
  )(),
  apiUrl: composeValidators(
    hasLengthLessThan(1025)({
      message: "La API URL debe tener máximo 1024 caracteres",
    }),    
    hasLengthGreaterThan(7)({
      message: "La API URL debe tener al menos 8 caracteres",
    }),
    matchesPattern(/[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/)({
      message: "Por favor digite una URL valida",
    }),
  )(),
});

const Integration = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const {
    supplier,
    btIntegrationSupplier,
    updateIntegration,
  } = rootStore.companyStore;

  const [integrationForm] = useState<IIntegration>({
    apiKey: supplier?.apiKey || "",
    apiUrl: supplier?.apiUrl || "",
  });

  const handleFinalFormSubmit = (values: IIntegration) => {
    if (
      integrationForm.apiKey !== values.apiKey ||
      integrationForm.apiUrl !== values.apiUrl
    ) {
      updateIntegration(values);
    } else toast.error("No ha hecho ningún cambio");
  };
  return (
    <div className="tabContentStyle">
      <FinalForm
        validate={validate}
        initialValues={integrationForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>API URL</label>
              <Field
                name="apiUrl"
                component={TextInput}
                defaultValue={integrationForm.apiUrl}
              />
              <label>API KEY</label>
              <Field
                name="apiKey"
                component={TextInput}
                defaultValue={integrationForm.apiKey}
              />
              <br />
              <Button
                loading={btIntegrationSupplier}
                disabled={btIntegrationSupplier}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(Integration);
